import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginLayoutComponent } from './layout/login-layout.component';
import { LoginComponent } from './login/login.component';
import { HomeLayoutComponent } from './layout/home-layout.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { AuditLogComponent } from './audit-log/audit-log.component';
import { FolderListingsPageComponent } from './folder-listings-page/folder-listings-page.component';
import { AccessRequestComponent } from './access-request/access-request.component';
import { AddUserComponent } from './add-user/add-user.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent
      }
    ]
  },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [],
    children: [
      { path: 'home', component: HomeComponent },
      { path: 'folder-listings', component: FolderListingsPageComponent },
      { path: 'audit-log', component: AuditLogComponent },
      { path: 'access-request', component: AccessRequestComponent},
      { path: 'add-user', component: AddUserComponent},
    ]
  },
  // {
  //   path: 'access-request',
  //   component: AccessRequestComponent
  // },
  
  { path: 'unauthorized', component: NotAuthorizedComponent },
  { path: '**', pathMatch: 'full', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
